import Button from '@shared/components/core/button/CoreButton';
import PageBannerCard from '@shared/components/core/card/PageBannerCard';
import { useTranslation } from 'react-i18next';

// TODO ADMIN PANEL: Update Project upgrade to link to billing page when API integration is complete.
export default function ProjectsUpgradeBanner() {
    const { t } = useTranslation();

    return (
        <PageBannerCard
            description={t('common:organization.projects.upgrade.description')}
            fullHeight
            icon="virtualApps"
            title={t('common:organization.projects.upgrade.title')}>
            <Button href="https://cephable.com/sdk-trial/" target="_blank" startIcon="plusLight">
                {t('common:upgrade')}
            </Button>
        </PageBannerCard>
    );
}
